export default {
  data() {
    return {
      documents: {
        data: [],
      },
    };
  },
  methods: {
    populateWithDocuments(documents) {
      documents.forEach((document) => {
        // Add selected property. Is used for multiple select
        document.selected = false;

        this.documents.data.push(document);
      });
    },
    addDocumentsOnInit(documents) {
      documents.forEach((document) => {
        // Add selected property. Is used for multiple select
        document.selected = false;

        this.documents.data.push(document);
      });
    },
    addDocumentNewFile(document) {
      document.selected = false;

      this.documents.data.unshift(document);
    },
    getDocumentMediaFile(id) {
      return this.documents.data.find(document => document.id === id);
    },
    updateDocumentMedia(id, params) {
      this.documents.data.find((document) => {
        if (document.id === id) {
          document.title = params.title;
          document.description = params.description;
        }
      });
    },
    deleteDocumentMedia(id) {
      this.documents.data = this.documents.data.filter(document => document.id !== id);
    },
  },
};
